<div *ngIf="value && (value.length && value.length > 0)">
  <ng-container [ngSwitch]="field.widget.type">
    <ng-container *ngSwitchCase="'file'">
      <ub-form-readable label="{{ field.title }}" display="block">
        <eas-file-upload-control richText
                                 [readonly]="true"
                                 [readonlyValue]="value">
        </eas-file-upload-control>
      </ub-form-readable>
    </ng-container>
    <ng-container *ngSwitchDefault i18n>
      <ub-form-readable label="{{ field.title }}" value="{{ field.getTitle(value)  }}" display="block"></ub-form-readable>
    </ng-container>
  </ng-container>

</div>